<template>
    <div>
        <topnav @navtype="navtype" :toptype="toptype"></topnav>
        <div class="" style="min-height: 600px">
            <div v-if="configs" class="block">
                <!-- <el-carousel trigger="click" height="700px">
          <el-carousel-item v-for="(item,index) in swiperlist" :key="index">
            <el-image style="width: 100%; height: 700px" :src="item.url" fit="fill"></el-image>
          </el-carousel-item>
        </el-carousel> -->
                <el-image style="width: 100%; height: 500px;display: block" :src="configs.shouye_pic | addurl"></el-image>
            </div>
            <div class="response bg-gray">
                <div class="flex justify-center align-center flex-direction">
                    <div class="title">精选创业服务</div>
                    <div class="titleline"></div>
                </div>
                <div ref="altas" class="server-group  marginauto flex align-center flex-wrap" style="width: 1325px">
                    <!-- bounceInLeft flipInY flipInX jackInTheBox zoomIn slideInRight-->
                    <template v-for="(item,index) in tlist">
                        <div @click="tonext(item.path)" class="serviceone pointer animated bounceInLeft slow hvr-glow ttttt">
                            <div class="flex justify-between align-center stop">
                                <!-- <div class="simg"></div> -->
                                <el-image class="simg" :src="item.image" fit="fill"></el-image>
                                <div class="scon">
                                    <div class="stitle">{{item.title}}</div>
                                    <div class="sinfo">{{item.english}}</div>
                                </div>
                                <div class="">
                                    <i class="el-icon-arrow-right rightarrow"></i>
                                </div>
                            </div>
                            <div class="sbot flex justify-start align-center flex-wrap" v-if="index==3">
                                <div v-for="(items,indexs) in item.list" :key="indexs" class="botlist text-cut">{{items.title}}</div>
                            </div>
                            <div class="sbot flex justify-start align-center flex-wrap" v-else>
                                <div v-for="(items,indexs) in item.list" :key="indexs" class="botlist text-cut">{{items.name ? items.name : items.shop_name}}</div>
                            </div>
                        </div> 
                    </template>

                </div>
            </div>
            <div class="marginauto" style="width: 1325px;padding: 60px 0 38px 0;">
                <div class="flex justify-center align-center flex-direction">
                    <div class="title">企业入驻</div>
                    <div class="titleline"></div>
                </div>
                <div ref="qyrz" class="response flex justify-start align-start" style="margin-bottom: 70px;">
                    <el-col :span="9">
                        <el-image v-show="qyrzshow" class=" animated flipInX slow" style="margin-right: 20px;" src="/static/assets/images/index/img4.png" fit="fill"></el-image>
                    </el-col>
                    <el-col :span="12">
                        <div style="color: #a7a7a7;font-size: 18px;line-height: 28px;min-height: 200px">
                            {{configs.qyrz_intro ? configs.qyrz_intro : ''}}
                        </div>
                        <div @click="toapply" class="cbtn pointer">
                            立即申请
                        </div>
                    </el-col>
                </div>
                <div ref="lease" class="flex justify-start align-center response">
                    <div v-show="leaseshow" class="cone animated zoomIn slow pointer hvr-glow" v-for="(item,index) in lease_list" :key="index" @click="toroomdetail(item.id)">
                        <el-image style="width: 100%;height: 205px;" :src="item.image | addurl" fit="fill"></el-image>
                        <div class="" style="padding: 20px 28px;">
                            <div class="flex justify-start align-center">
                                <div class="colortwo">房间号：</div>
                                <div class="colorone">{{item.number}}</div>
                            </div>
                            <div class="flex justify-start align-center" style="margin: 20px 0;">
                                <div class="colortwo">位 置：</div>
                                <div class="colorone">{{item.position}}楼</div>
                            </div>
                            <div class="flex justify-start align-center">
                                <div class="colortwo">工位数：</div>
                                <div class="colorone">{{item.work}}</div>
                            </div>
                        </div>
                        <div @click="shownow(item.id)" class="csbtn text-center">
                            立即咨询
                        </div>
                    </div>
                </div>
                <div class="response flex justify-center">
                    <div @click="tonext('/tenancy')" class="tomore pointer hvr-wobble-horizontal">
                        查看更多
                    </div>
                </div>
            </div>
            <div ref="article" class="response bgblue">
                <div class="marginauto" style="width: 1325px;padding: 100px 0;">
                    <div class="flex  align-center" style="margin-bottom: 70px;">
                       <div style="display: flex;align-items: flex-end;">
						   <div class="text-white" v-if="tabindex == 0" style="font-size: 55px;font-weight: 600;">政府通告</div>
						   <div class="text-white" v-if="tabindex == 1" style="font-size: 55px;font-weight: 600;">通知资讯</div>
						   <!-- <div class="text-white" v-if="tabindex == 2" style="font-size: 55px;font-weight: 600;">最新资讯</div> -->
						   <div style="margin-left: 30px;margin-bottom: 5px;">
						   	<div class="geng" @click="liadetail">了解更多->
						   	<div class="yin"></div>
						   	</div>
						   </div>
					   </div>
                        <div class="flex justify-center align-center" style="margin-left: 80px;">
                            <div class="tabone pointer" @click="tabchange(0)" :class="tabindex == 0 ? 'tabactive':''">
                                政府通告
                            </div>
                            <div class="tabone pointer" @click="tabchange(1)" :class="tabindex == 1 ? 'tabactive':''">
                                通知资讯
                            </div>
                            <!-- <div class="tabone pointer" @click="tabchange(2)" :class="tabindex == 2 ? 'tabactive':''">
                                资讯
                            </div> -->
                        </div>
                    </div>
                    <el-row v-show="articleshow" class="slideInRight animated" :gutter="24">
                        <el-col :span="9">
                            <!-- hvr-push  hvr-pop-->
                            <div class="leftblock pointer" v-if="articlelist.length" @click="topdetail(articlelist[0].id,tabindex)">
                                <div class="" style="margin-bottom: 30px;color: #64f2ff;font-size: 30px;">{{articlelist[0].release_time ? articlelist[0].release_time : articlelist[0].date}}</div>
                                <div class="" style="margin-bottom: 85px;color: #64f2ff;font-size: 22px;">{{articlelist[0].title}}</div>
                                <div class="text-white text-cut4" style="font-size: 18px;line-height: 36px;" v-html="articlelist[0].content">
                                    <!-- {{articlelist[0].content}} -->
                                </div>
                                <!-- <el-image src="/static/assets/images/p4.jpg" fit="fill"></el-image> -->
                            </div>
                        </el-col>
                        <el-col :span="14" :class="showan ? 'slideInRight animated':''">
                            <div class="newsone pointer" v-for="(item,index) in articlelist" :key="index" v-if="index<4"  @click="topdetail(item.id,tabindex)">
                                <div  class="">
                                    <div class="ntop flex justify-between align-end">
                                        <div class="flex justify-start align-center">
                                            <div class="text-cut" style="color: #64f2ff;margin-right: 10px;max-width: 500px;">{{item.title}}</div>
                                        </div>
                                        <div class="flex">
                                            <div class="" style="color: #64f2ff;margin-right: 50px;">
                                                <!-- <span style="font-size: 28px;">{{item.month}}</span><span style="font-size: 18px;">/{{item.day}}</span> -->
                                                {{item.release_time ? item.release_time : item.date}}
                                            </div>

                                            <div class="" style="color: #64f2ff;font-size: 16px;">
                                                详情 →
                                            </div>
                                        </div>
                                    </div>
                                    <div class="response" style="background-color: #64f2ff;height: 3px;margin-top: 15px;"></div>
                                    <div class="text-white text-cut2" style="font-size: 18px;line-height: 32px;margin-top: 10px;min-height: 64px">
                                        <!--  v-html="item.content" --> {{item.content}}
                                    </div>
                                </div>
                            </div>
							 
							 
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div ref="partner" class="response bg-gray">
                <div class="marginauto" style="width: 1325px;">
                    <div class="flex justify-center align-center flex-direction">
                        <div class="title">合作伙伴</div>
                        <div class="titleline"></div>
                    </div>
                    <el-row :gutter="24">
                        <el-col :span="6" v-for="(item,index) in partner_list" v-show="partnershow" class="animated jackInTheBox" :key="index">
                            <div class="flex justify-center flex-direction pointer">
                                <div @click="toout(item.href)" class="marginauto bg-white flex justify-center hvr-wobble-skew" style="width: 290px;height:70px;overflow:hidden;border-radius: 6px;">
                                    <el-image class="" style="height: 70px;" :src="item.image | addurl" fit="fill"></el-image>
                                </div>
                                <div class="text-center text-cut" style="font-size: 20px;color: #929191;margin-top: 24px;margin-bottom: 70px;">{{item.name}}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>

        </div>
        <el-dialog title="咨询" :visible.sync="addcompany">
            <div class="" style="text-align: center;width: 60%;margin: 0 auto;">
                <el-form :model="cominfo" style="text-align:center;">
                    <el-form-item label="姓名" :label-width="formLabelWidth">
                        <el-input style="width: 420px;" placeholder="请输入" v-model="cominfo.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="电话" :label-width="formLabelWidth">
                        <el-input style="width: 420px;" placeholder="请输入" v-model="cominfo.phone" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="咨询内容" :label-width="formLabelWidth">
                        <el-input type="textarea" :rows="2" style="width: 420px;" placeholder="请输入咨询内容" v-model="cominfo.content" autocomplete="off"></el-input>
                    </el-form-item>

                </el-form>
            </div>

            <div slot="footer" class="flex justify-center align-center">
                <el-button :disabled="nowdisabled" @click="tosub" type="primary">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters(["token", "type"]),
    },
    data() {
        return {
            tabindex: 0,
            showan: false,
            toptype: 1,
            articlelist: [],
            swiperlist: [
                {
                    url: "../../static/assets/images/p1.jpg",
                    fit: "fill",
                },
                {
                    url: "../../static/assets/images/p2.jpg",
                    fit: "fill",
                },
                {
                    url: "../../static/assets/images/p3.jpg",
                    fit: "fill",
                },
                {
                    url: "../../static/assets/images/p4.jpg",
                    fit: "fill",
                },
            ],
            lease_list: [],
            configs: "",
            partner_list: [],
            tlist: [
                {
                    title: "创业服务",
                    english: "BUSINESS SERVICES",
                    image: "../../static/assets/images/index/index3.png",
                    path: "/risk",
                    list: [],
                },
                {
                    title: "政策服务",
                    english: "INCUBATION SERVICES",
                    image: "../../static/assets/images/index/index5.png",
                    path: "/finance",
                    list: [],
                },
                {
                    title: "活动资讯",
                    english: "TRAINING SERVICES",
                    image: "../../static/assets/images/index/index4.png",
                    path: "/train",
                    list: [
                        {
                            name: "法律普及",
                        },
                        {
                            name: "金融动态",
                        },
                    ],
                },
                {
                    title: "场地服务",
                    english: "INFORMATION SERVICES",
                    path: "/tenancy",
                    image: "../../static/assets/images/index/index1.png",
                    list: [],
                },
                {
                    title: "在孵企业",
                    english: "ENTERPRISE",
                    image: "../../static/assets/images/index/index6.png",
                    path: "/company",
                    list: [
                        {
                            name: "在孵企业",
                        },
                        {
                            name: "企业入驻",
                        },
                    ],
                },
            ],
            addcompany: false,
            cominfo: {
                question_id: "",
                type: 3,
                company_name: "",
                name: "",
                phone: "",
                content: "",
                user_id: "",
            },
            formLabelWidth: "120px",
            altasShow: false,
            qyrzshow: false,
            leaseshow: false,
            articleshow: false,
            partnershow: false,

            nowdisabled: false,
        };
    },
    methods: {
		liadetail(){
			// console.log(this.tabindex)
			if(this.tabindex==0){
				this.$router.push({ path: "/latestpolicy" });
			}else{
				this.$router.push({ path: "/noticelist",query:{type:this.tabindex}});
			}
			  
		},
        toroomdetail(id) {
            this.$router.push({ path: "/tenancydetail", query: { id: id } });
        },
        toout(href) {
            // console.log(href)
            window.open(href);
        },
        toapply() {
            if (!this.token) {
                this.$message.error("请登录！");
                setTimeout(() => {
                    this.$router.push({ path: "/login" });
                }, 1000);
                return false;
            }
            if (this.type == 1) {
                this.$message.error("请切换为个人登录！");
                return false;
            } else if (this.type == 2) {
                if (this.info.shop) {
                    if (this.info.shop.status == 0) {
                        this.$message("申请已提交，正在审核中");
                        return false;
                    } else if (this.info.shop.status == 2) {
                        this.$alert(
                            this.info.shop.remark,
                            "您的申请被拒绝,请重新申请",
                            {
                                confirmButtonText: "确定",
                                callback: (action) => {
                                    this.$router.push({
                                        path: "/companyinfo",
                                        query: { id: this.info.shop.id },
                                    });
                                },
                            }
                        );
                        return false;
                    } else if (this.info.shop.status == 1) {
                        this.$message("您已成功入驻！");
                        return false;
                    }
                }
            }
            this.$router.push({ path: "/companyinfo" });
        },
        shownow(id) {
            if (!this.token) {
                this.$message.error("请登录");
                etTimeout(() => {
                    this.$router.push({ path: "/login" });
                }, 1000);
                return false;
            }
            this.addcompany = true;
            this.cominfo.question_id = id;
        },
        tosub() {
            // question_add
            if (
                !this.cominfo.content ||
                !this.cominfo.phone ||
                !this.cominfo.name
            ) {
                this.$message({
                    message: "请完善信息",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            if (!this.cominfo.phone) {
                this.$message({
                    message: "请输入手机号",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            if (!/^1[3456789]\d{9}$/.test(this.cominfo.phone)) {
                this.$message({
                    message: "手机号码错误！",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            this.cominfo.user_id = this.token;
            this.nowdisabled = true;
            this.$api.index
                .question_add(this.cominfo)
                .then((response) => {
                    // console.log(response)
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: 1000,
                    });
                    this.addcompany = false;
                    this.cominfo.phone = "";
                    this.cominfo.name = "";
                    this.cominfo.content = "";
                    this.nowdisabled = false;
                })
                .catch(() => {
                    this.nowdisabled = false;
                });
        },
        getuserinfo() {
            var type = localStorage.getItem("type");
            if (type == 2) {
                var types = 1;
            } else if (type == 1) {
                var types = 2;
            }
            var data = {
                user_id: this.token,
                type: types,
            };
            this.$api.user.userinfo(data).then((res) => {
                var data = res.data;
                this.info = data;
                var sdata = JSON.stringify(data);
                // this.$store.commit('SET_USERINFO',sdata)
                localStorage.setItem("userinfo", sdata);
            });
        },
        topdetail(id, type) {
            let routeData = this.$router.resolve({
                name: "policydetail",
                query: { id: id, type: type },
            });
            window.open(routeData.href, "_blank");
            // this.$router.push({path: '/policydetail',query: {id: id,type: type}})
        },
        tonext(path) {
            this.$router.push({ path: path });
        },
        navtype(type) {
            this.toptype = type;
        },
        tabchange(e) {
            this.tabindex = e;
            this.showan = false;
            if (e == 0) {
                this.getpolicy();
            } else {
                this.getarticle(e);
            }
        },
        getconfig() {
            this.$api.index.config().then((response) => {
                // this.list = response.data.items
                // console.log(response)
                this.configs = response.data;
                var s = JSON.stringify(response.data);
                localStorage.setItem("config", s);
            });
        },
        getpolicy() {
            this.$api.index
                .home_policy()
                .then((response) => {
                    // this.list = response.data.items
                    this.articlelist = response.data;
                    this.showan = true;
                    // console.log(response)
                })
                .catch(() => {
                    this.showan = false;
                });
        },
        getarticle(type) {
            var data = {
                type: type,
				start:0,
				page_size:8
            };
            this.$api.index
                .article_list(data)
                .then((response) => {
                    this.articlelist = response.data;
                    // console.log(response)
                    this.showan = true;
                })
                .catch(() => {
                    this.showan = false;
                });
        },
        getlease_list() {
            var data = {
                start: 1,
                page_size: 4,
            };
            this.$api.index.lease_list(data).then((response) => {
                // console.log('lease_listlease_list',response)
                this.lease_list = response.data;
            });
        },
        getpartner() {
            this.$api.index.partner_list().then((response) => {
                // console.log(response)
                this.partner_list = response.data;
            });
        },
        handleScroll() {
            let _this = this;
            let refArray = [
                { ref: "altas", show: "altasShow" },
                { ref: "qyrz", show: "qyrzshow" },
                { ref: "lease", show: "leaseshow" },
                { ref: "article", show: "articleshow" },
                { ref: "partner", show: "partnershow" },
            ];
            // console.log('refArray',refArray)
            refArray.forEach((r, i) => {
                // console.log('refArrayrefArray',r);
                _this.watchsroll(r.ref, 80, () => {
                    // console.log(11111111,r.show)
                    _this[r.show] = true;
                });
            });
        },
        watchsroll(div, offset, callback) {
            let dom = this.$refs[div];
            // console.log(11111111,this.$refs.altas)
            // console.log(11111111,this.$refs)
            if (dom) {
                var a, b, c, d;
                d = dom.offsetTop;
                a = eval(d + offset);
                b =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;
                c =
                    document.documentElement.clientHeight ||
                    document.body.clientHeight;
                if (b + c > a) {
                    callback && callback();
                }
            }
        },
        getsort(cat_id) {
            var data = {
                cat_id: cat_id,
            };
            this.$api.index.tech_category(data).then((res) => {
                this.tlist[1].list = res.data;

                this.$forceUpdate();
            });
        },
        getsorttwo() {
            this.$api.index.train_category().then((res) => {
                this.tlist[2].list = res.data;
            });
        },
        cyfulist() {
            this.$api.index.getcyfulist().then((res) => {
                this.tlist[0].list = res.data;
                console.log(this.tlist[0].list, 66666);
            });
        },
        getfinancelist() {
            var data = {
                start: 1,
                page_size: 4,
            };
            this.$api.index.lease_list(data).then((res) => {
                this.tlist[3].list = res.data;
                console.log(this.tlist[3].list, 555555);
            });
        },
        getcomlist() {
            var data = {
                start: 1,
                page_size: 3,
            };
            this.$api.index.shop_list(data).then((res) => {
                console.log("res.data", res.data);
                this.tlist[4].list = this.tlist[4].list.concat(res.data);
                // console.log(this.tlist[4].list)
                this.$forceUpdate();
            });
        },
        getcomlist() {
            var data = {
                start: 1,
                page_size: 3,
            };
            this.$api.index.finance_list(data).then((res) => {
                console.log("res.data", res.data);
                this.tlist[1].list = this.tlist[1].list.concat(res.data);
                // console.log(this.tlist[4].list)
                this.$forceUpdate();
            });
        },
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },
    created() {
        this.getconfig();
        this.getpolicy();
        this.getlease_list();
        this.getpartner();
        this.getsort(0);
        this.getsorttwo();
        this.cyfulist();
        this.getfinancelist();
        this.getcomlist();
        if (this.token) {
            this.getuserinfo();
        }
    },
};
</script>
<style>
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
}
</style>
<style scoped>
.bg-gray {
    background-color: #eef1fa;
    padding: 78px 0 35px 0;
}
.title {
    color: #1a1a1a;
    font-size: 36px;
    font-weight: 600;
}
.titleline {
    width: 41px;
    height: 7px;
    background-color: #005fed;
    margin: 12px 0 50px 0;
}


.serviceone {
    width: 431px;
    height: 339px;
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 10px;
    margin-right: 16px;
}

.server-group .serviceone:nth-child(3n){
    margin-right: 0px;
}

.stop {
    height: 154px;
    padding: 0 30px 0 22px;
    border-bottom: 1px solid #eee;
}
.simg {
    width: 87px;
    height: 87px;
    border-radius: 50%;
    display: block;
    /* background-color: #e2eeff; */
}
.scon {
    width: 65%;
}
.stitle {
    color: #414141;
    font-size: 32px;
    margin-bottom: 10px;
    font-weight: 600;
}
.sinfo {
    color: #8f8f8f;
    font-size: 20px;
}
.rightarrow {
    color: #bcc2ca;
    font-size: 24px;
    font-weight: 600;
}
.sbot {
    padding: 25px 30px 0 30px;
    max-height: 130px;
    overflow: hidden;
}
.botlist {
    padding: 0 20px;
    line-height: 42px;
    color: #545454;
    margin: 10px 5px;
    height: 42px;
    background-color: #f3f3f3;
    border-radius: 21px;
}
.botlist:hover {
    background: #00a0fd;
    color: #fff;
}
.cbtn {
    width: 550px;
    height: 71px;
    line-height: 71px;
    background-image: linear-gradient(86deg, #005aeb 0%, #00a0fd 100%);
    border-radius: 3px;
    color: #ffffff;
    font-size: 26px;
    text-align: center;
    margin-top: 35px;
}
.cone {
    width: 308px;
    border: solid 1px #e5e5e5;
    margin-right: 28px;
}
.cone:last-child {
    margin: 0;
}
.csbtn {
    height: 48px;
    width: 100%;
    line-height: 48px;
    background-image: linear-gradient(86deg, #005aeb 0%, #00a0fd 100%);
    border-radius: 3px;
    font-size: 18px;
    color: #fff;
}
.colorone {
    color: #ffa10e;
    font-size: 20px;
}
.colortwo {
    color: #1e1e1e;
    font-size: 18px;
    width: 80px;
}
.tomore {
    margin-top: 40px;
    width: 363px;
    height: 75px;
    color: #0065ee;
    line-height: 75px;
    font-size: 22px;
    text-align: center;
    background-color: #ffffff;
    border-radius: 38px;
    border: solid 1px #006bef;
}
.bgblue {
    background-color: #192064;
    min-height: 910px;
}
.tabone {
    width: 146px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #b1b5c0;
    margin: 0 20px;
    border: solid 1px #192064;
}
.tabactive {
    color: #64f2ff;
    border: solid 1px #64f2ff;
}
/* .tabone:hover{
    color: #64f2ff;
    background-color: #fff;
  } */
.leftblock {
    width: 405px;
    height: 505px;
    background-color: #192064;
    border: solid 1px #6af0e9;
    padding: 40px 30px;
}
.newsone {
    margin-bottom: 25px;
}
.newsone:last-child {
    margin-bottom: 0;
}
.geng{
	width: 150px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	border: 1px solid #fff;
	text-align: right;
	color: #fff;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
 
.yin{
	position: absolute;
	width: 100%;
	height: 100%;
	left: -150px;
	background-color: rgb(100, 242, 255);
	transition: 1s;
	opacity: 0.2;
}
.geng:hover .yin{
	left: 0;
}
</style>




// WEBPACK FOOTER //
// Home.vue?6f5c228d